<template>
  <div ref="layout" class="grey darken-1 empty-layout">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EmptyLayout",
  computed: {
    ...mapGetters("ui", ["isMobile"]),
  },
  mounted() {
    this.updateHeight();
    window.addEventListener("resize", this.updateHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateHeight);
  },
  methods: {
    updateHeight() {
      if (this.isMobile && this.$refs.layout) {
        this.$refs.layout.style.height = `${window.innerHeight}px`;
      } else if (this.$refs.layout) {
        this.$refs.layout.style.height = "100vh";
      }
    },
  },
  watch: {
    isMobile() {
      this.updateHeight();
    },
  },
};
</script>


<style scoped>

.empty-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--primary-background-light);
}

.my-app-dark .empty-layout {
  background-color: var(--primary-background-dark);
  color: #fff;
}

</style>
